import React, { useState } from "react";
//Components
import { BackButton } from "../components/generics/BackButton";
import CategoryCard from "../components/CategoryCard";
import { DeParaReport } from "../DeParaReport";
import { SentItemsReport } from "../SentItemsReport";
//interfaces
import { IReportPage } from "./interface";
//assets
import dIcon from "img/d-icon.svg";
import sentItemsIcon from "img/sent-items-icon.svg";
//styles
import { CategoryArea, ReportsContent, Title } from "./styles";

export const ReportsPage: React.FC<IReportPage> = () => {
  const [showDeParaModal, setShowDeParaModal] = useState(false);
  const [showSentItemsModal, setShowSentItemsModal] = useState(false);

  return (
    <ReportsContent>
      <BackButton />
      <Title>Relatórios</Title>

      <CategoryArea>
        <CategoryCard
          title="De/Paras"
          icon={dIcon}
          onClick={() => setShowDeParaModal(true)}
        />
        <CategoryCard
          title="ITENS ENVIADOS"
          icon={sentItemsIcon}
          onClick={() => setShowSentItemsModal(true)}
        />
      </CategoryArea>

      {showDeParaModal && (
        <DeParaReport
          isOpen={showDeParaModal}
          onClose={() => setShowDeParaModal(false)}
        />
      )}

      {showSentItemsModal && (
        <SentItemsReport
          isOpen={showSentItemsModal}
          onClose={() => setShowSentItemsModal(false)}
        />
      )}
    </ReportsContent>
  );
};
